var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth-auth-module"
	],
	"./quiz/quiz.module": [
		"./src/app/views/quizzes/quiz/quiz.module.ts",
		"default~quiz-quiz-module~views-quizzes-quizzes-module",
		"common",
		"quiz-quiz-module"
	],
	"./views/certifications/certifications.module": [
		"./src/app/views/certifications/certifications.module.ts",
		"default~views-certifications-certifications-module~views-quizzes-quizzes-module",
		"common",
		"views-certifications-certifications-module"
	],
	"./views/quizzes/quizzes.module": [
		"./src/app/views/quizzes/quizzes.module.ts",
		"default~quiz-quiz-module~views-quizzes-quizzes-module",
		"default~views-certifications-certifications-module~views-quizzes-quizzes-module",
		"common",
		"views-quizzes-quizzes-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;